export default class ContentGuruChat {
  constructor() {
    this.BUSINESS_HOURS = {
      start: 8 * 60 + 30, // 08:30
      end: 17 * 60 // 17:00
    };

    this.updateFloatingContactVisibility();
    this.updateWidgetVisibility();
  }

  updateFloatingContactVisibility() {
    const container = document.querySelector('.denhaag-floating-contact-overlay .denhaag-floating-contact__item--chat');
    const link = container?.querySelector('.denhaag-floating-contact__item-link');
    const statusIndicator = container?.querySelector('.denhaag-chat-status');
    
    if (container && link && statusIndicator) {
      const contentguruUrl = link.getAttribute('href');
      if (contentguruUrl) {
        this.updateFloatingContact(link, statusIndicator, contentguruUrl);
      }
    }
  }

  updateWidgetVisibility() {
    const link = document.querySelector('.denhaag-chat-link');
    if (link) {
      link.style.display = this.isOnline() ? 'inline' : 'none';
    }
  }

  isWeekday() {
    const day = new Date().getDay();
    return day !== 0 && day !== 6; // 0 = Sunday, 6 = Saturday
  }

  isWithinBusinessHours() {
    const now = new Date();
    const currentTime = now.getHours() * 60 + now.getMinutes();
    return currentTime >= this.BUSINESS_HOURS.start && currentTime <= this.BUSINESS_HOURS.end;
  }

  isOnline() {
    return this.isWeekday() && this.isWithinBusinessHours();
  }

  getClosedText() {
    const lang = document.documentElement.lang || '';
    return lang.toLowerCase().startsWith('nl') ? 'Gesloten' : 'Closed';
  }

  updateFloatingContact(linkElement, statusElement, contentguruUrl) {
    const isOnline = this.isOnline();
    
    // Update status indicator
    statusElement.className = 'denhaag-chat-status' + 
      (isOnline ? ' denhaag-chat-status--online' : ' denhaag-chat-status--offline');
    
    // Update link/status text
    if (isOnline) {
      linkElement.outerHTML = `
        <a class="denhaag-floating-contact__item-link" href="${contentguruUrl}" target="_blank" rel="noopener noreferrer">
          Open chat
          <span class="sr-only">(External link)</span>
        </a>
      `;
    } else {
      linkElement.outerHTML = `
        <span class="denhaag-floating-contact__item-link">${this.getClosedText()}</span>
      `;
    }
  }
}
